import FirebaseUsage from "../firebase.usage";
import {COLLECTIONS} from "../constants";
import {DefaultSubscribeCallback} from "../../store/middleware/middlewares";
import ProjectMembersModel from "../../models/responses/project-members.model";
import {ReportItem} from "../../store/store.types";
import {PendingMembershipsModel} from "../../models/pending-memberships.model";

const colorPalette = [
    '#e879f9', '#c084fc', '#f472b6', '#38bdf8', '#2dd4bf', '#f87171', '#fb923c', '#a3e635'
]

export class MemberSubscriptions {
    static projectPermission(userId: string | null, callback: DefaultSubscribeCallback<ProjectMembersModel[]>) {
        return FirebaseUsage.getQuery(COLLECTIONS.PROJECT_MEMBERS, ['userId', '==', userId])
            .then(data => {
                const members: ProjectMembersModel[] = data.docs.map(el => el.data() as ProjectMembersModel);
                callback(members);
            });
    }

    static userNotifications(userId: string, contractId: string | null, limit: number = 10, callback: DefaultSubscribeCallback<any[]>) {
        return contractId ?
            FirebaseUsage.queryListenerWithOrderAndLimit(COLLECTIONS.USER_NOTIFICATIONS,
                [['userId', '==', userId], ['contractId', '==', contractId]],
                ['timestamp', 'desc'],
                limit,
                (data: { docs: any[]; }) => {
                    callback(data.docs.map(el => ({...el.data(), uuid: el.id})));
                }) :
            FirebaseUsage.queryListenerWithOrderAndLimit(COLLECTIONS.USER_NOTIFICATIONS,
                [['userId', '==', userId]],
                ['timestamp', 'desc'],
                limit,
                (data: { docs: any[]; }) => {
                    callback(data.docs.map(el => ({...el.data(), uuid: el.id})));
                });
    }

    static async memberList(contractId: string, callback: DefaultSubscribeCallback<ProjectMembersModel[]>) {
        return FirebaseUsage.queryListener(COLLECTIONS.PROJECT_MEMBERS, [['contractId', '==', contractId]], (data) => {
                callback(data.docs.map((el) => ({...el.data(),
                    userColour: colorPalette[(el.data().userEmail.charCodeAt(0) * el.data().userEmail.charCodeAt(1)) % colorPalette.length]
                }) as ProjectMembersModel)
                    .sort((a, b) => a.userEmail.localeCompare(b.userEmail))
                    // .sort((a, b) => a.grade === "Groups" ? -1 : 1)
                );
        })
    }

    static pendingMembers(contractId: string, callback: DefaultSubscribeCallback<PendingMembershipsModel[]>) {
        return FirebaseUsage.getQuery(COLLECTIONS.PENDING_MEMBERSHIPS, ['contractId', '==', contractId])
            .then(data => {
                callback(data.docs.map(el => el.data() as PendingMembershipsModel));
            });
    }

    static projectMember(contractId: string, userId: string, callback: DefaultSubscribeCallback<ProjectMembersModel>) {
        return FirebaseUsage.queryListener(COLLECTIONS.PROJECT_MEMBERS,
            [['contractId', '==', contractId],
                ['userId', '==', userId]], (data) => {
            callback(data.docs[0].data() as ProjectMembersModel);
        });
    }

    static reportList(projectId: string, callback: DefaultSubscribeCallback<ReportItem[]>) {
        return FirebaseUsage.getQuery(COLLECTIONS.REPORTS, ['projectId', '==', projectId])
            .then(data => {
                callback(
                    data.docs.map(el => ({
                        // @ts-ignore
                        uuid: el.id, ...el.data()
                    })) as ReportItem[]
                );
            });
    }
}
